import { Falcon } from '@pocketlaw/tetris/macro';
import { StyledChip } from './styled';
export function FilterChip(props) {
    const { label, count, selected, onAdd, onRemove } = props;
    const toggle = selected ? onRemove : onAdd;
    return (<StyledChip onClick={toggle} appearance="secondary" label={label} secondary={`(${count})`} variant={selected ? 'solid' : 'outline'} icon={selected ? <Falcon icon="check"/> : undefined}/>);
}
